import { useRequiredContext } from "@redotech/react-util/context";
import { TeamContext } from "@redotech/redo-merchant-app-common/team";
import { anyOrderEditingActionEnabled } from "@redotech/redo-order-editing-settings-common/order-editing-match";

import { createContext, memo } from "react";

export interface OrderEditingSuiteStatuses {
  orderEditingEnabled: boolean;
}

export const OrderEditingSuiteStatusesContext = createContext<
  OrderEditingSuiteStatuses | undefined
>(undefined);

export const OrderEditingSuiteStatusesProvider = memo(
  function OrderEditingSuiteStatusesProvider({
    children,
  }: {
    children: React.ReactNode;
  }) {
    const team = useRequiredContext(TeamContext);
    const orderEditingEnabled = anyOrderEditingActionEnabled(
      team?.settings?.orderEditing,
    );

    return (
      <OrderEditingSuiteStatusesContext.Provider
        value={{ orderEditingEnabled }}
      >
        {children}
      </OrderEditingSuiteStatusesContext.Provider>
    );
  },
);
